import type { TFunction } from 'i18next';

import { CHIP_PLACEHOLDER_VARIANTS, type ChipPlaceholderVariant } from '~/features/whatsapp/constants/templatePicker';

type EmptyChipHint = { text: string; variant: ChipPlaceholderVariant };

// Label identifies the chip; only the bracketed value switches between fallback and missing.
export function getEmptyChipHint(t: TFunction, label: string, resolvedValue: string | null | undefined): EmptyChipHint {
    const value = resolvedValue || t('WHATSAPP_CHAT.TEMPLATE_MODAL.MISSING_VALUE');

    return {
        text: t('WHATSAPP_CHAT.TEMPLATE_MODAL.FALLBACK_HINT', { label, value }),
        variant: resolvedValue ? CHIP_PLACEHOLDER_VARIANTS.DEFAULT : CHIP_PLACEHOLDER_VARIANTS.ERROR,
    };
}
